"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hotjar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const script_1 = __importDefault(require("next/script"));
const env_1 = require("../env");
function Hotjar({ hotjarId, version = '6', }) {
    return env_1.STAGE === 'production' ? ((0, jsx_runtime_1.jsx)(script_1.default, Object.assign({ id: "hotjar", async: true }, { children: `
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hotjarId},hjsv:${version}};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')
        ` }))) : null;
}
exports.Hotjar = Hotjar;
